export default "__VITE_ASSET__Daqf2GRV__"